import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ExportJobId } from '../models/export-data.type';
import { FileExportDataAdapterInterface } from './file-export-data-adapter.interface';

export abstract class FileExportDataAdapter<T, K extends ExportJobId> implements FileExportDataAdapterInterface<T, K> {
  abstract exportFile(data: T): Observable<K>;
  abstract downloadFile(jobId: ExportJobId['jobId'], rest?: Omit<K, 'jobId'>): Observable<HttpResponse<Blob>>;
}
